import { DateRange } from '../date-range';
import { CourseEntity } from '../entities/course';
import { Pair } from '../pair';
import { ResourceTypePair } from '../resource-type-pair';
import { BasePluginData } from './base-plugin-data';

export class TrainingScheduleData {
  title: string = "";
  course!: CourseEntity;
  participants: string[] = [];
  trainers: Pair[] = [];
  dateRanges: DateRange[] = [];
  removalOption: string = "";
  removalDateTime?: Date;
  endDate ?: Date;
  trainersRemarks?: string = "";
  trainingDetail?: string = "";
  resourceTemplateIds: ResourceTypePair[] = [];
  accessViaInvitedEmailOnly:Boolean=false;
}

export class TrainingSchedulesData extends BasePluginData {
  override get pluginStepName(): string { return 'TrainingSchedulesData'; }

  TrainingSchedulesData: TrainingScheduleData[] = [];
}
